











import Vue from 'vue';
import RuleKeyIndicator from '../components/overview/RuleKeyIndicator.vue';
import RuleTrends from '../components/overview/RuleTrends.vue';
import RuleApiOverview from '../components/overview/RuleApiOverview.vue';
import RuleLogs from '../components/overview/RuleLogs.vue';
import scheduleClient from '../apis';
import moment from 'moment';

export default Vue.extend({
  components: {
    RuleKeyIndicator,
    RuleTrends,
    RuleApiOverview,
    RuleLogs,
  },
  data() {
    return {
      start: moment().subtract('days', 20).format('YYYY-MM-DD hh:mm:ss'),
      end: moment().format('YYYY-MM-DD hh:mm:ss'),
    };
  },
});
